import React from 'react';
import Pressable from 'src/components/10-atoms/pressables/Pressable';
export function createTabBarNavButton(to) {
    const TabBarNavButton = ({ children, onPress, style, ...rest }) => (React.createElement(Pressable, { to: to, onPress: onPress, style: style, accessibilityRole: "link", ...rest }, children));
    TabBarNavButton.displayName = 'TabBarNavButton';
    return TabBarNavButton;
}
